import { useDispatch } from "react-redux";
import { CloseButton, CreateCollectionButton, CreateCollectionWrapper } from "../CreateCollection/CreateCollection.styled";
import { toggleConnectWalletModal } from "../../store/app/appSlice";
import { ConnectWalletMain } from "./ConnectWallet.syled";
import diamond from "../../assets/img/diamond.png";
import { Link } from "react-router-dom";

export const ConnectWallet = () => {
  const dispatch = useDispatch();

  return (
    <CreateCollectionWrapper>
      <ConnectWalletMain>
        <CloseButton onClick={() => dispatch(toggleConnectWalletModal())}>&#9587;</CloseButton>
        <img src={diamond} alt='diamond' />
        <h4>Connect Wallet</h4>
        <h6>A wallet is a simple and anonymous way to login. To create (mint) or buy an NFT, you should connes.</h6>
        <CreateCollectionButton>TON Wаllet</CreateCollectionButton>
        <span>
          By using TONTAKE, you agree to our <Link to='/terms-of-servic'>Terms of Use</Link> & <Link to='/privacy-policy'>Privacy Policy</Link>
        </span>
      </ConnectWalletMain>
    </CreateCollectionWrapper>
  );
};
